<template>
<div class="modal-card">
  <header class="modal-card-head">
    <p class="modal-card-title">Quit Game?</p>
  </header>
  <section class="modal-card-body">
    Are you sure you want to leave the game?
  </section>
  <footer class="modal-card-foot is-fullwidth">
    <div class="level is-mobile">
      <div class="level-left">
        <div class="level-item">
        </div>
      </div>
      <div class="level-right">
        <div class="level-item">
          <button
            class="button is-text"
            type="button"
            @click="$parent.close()">Cancel</button>
        </div>
        <div class="level-item">
          <button @click="onSave" class="button is-primary">
            Leave Game
          </button>
        </div>
      </div>
    </div>
  </footer>
</div>
</template>

<script>

export default {
  name: 'ub-confirm-leave.modal',
  props: [
    'next',
  ],
  data() {
    return {
    };
  },
  computed: {
  },
  methods: {
    onSave() {
      //* lets just go back to home
      this.$emit('confirmed', this.next);
      this.$parent.close();
    },
  },
  mounted() {
  },
  components: {
  },
};
</script>

<style lang="scss" scoped>

</style>
